import { faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import COLORS from "../styled.constants";
import LogoImg from "./LogoImg";
import Hamburger from "hamburger-react";

function Navbar() {
  const [isOpen, setOpen] = useState(false);
  // const [menuOpen, setMenuOpen] = useState(false);
  const NavWrapper = styled.div`
    width: 100%;
  `;
  const Navbar = styled.ul`
    position: fixed;
    display: flex;
    justify-content: space-between;
    /* align-items: center; */
    width: 100%;
    font-size: 1.3em;
    font-weight: 500;
    margin-top: 2rem;
    z-index: 100;

    @media screen and (max-width: 912px) {
      width: 100%;
      /* display: flex;
      justify-content: center; */
    }
    @media screen and (max-width: 912px) {
      flex-direction: column;
      /* flex-direction: column;
      margin: 0 auto;
      text-align: center;
      height: 100vh;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: gray; */
    }
  `;

  const Logo = styled.li`
    margin-left: 5rem;
    line-height: 3rem;

    /* :hover {
      border-bottom: 1px solid ${COLORS.button};
    } */

    @media screen and (max-width: 912px) {
      margin-left: 0;
      margin-right: 1.3rem;
    }
    @media screen and (max-width: 768px) {
      margin-left: 0.5rem;
      /* text-align: right; */
      /* display: none; */
      /* margin-right: 0;
      text-align: center;
      margin-bottom: 1.2rem; */
    }
  `;

  const Menu = styled.ul`
    /* display: flex;
    justify-content: center; */
    /* align-items: space-around; */
    /* width: 20%; */
    margin-right: 2rem;
    height: 100vh;
    margin-right: 0;

    /* background-color: gray;
    height: 100vh; */

    @media screen and (max-width: 912px) {
      /* flex-direction: column; */
      /* margin: 0 auto;
      height: 100vh;
      
      display: flex;
      justify-content: center; */
      /* align-items: center; */
      background-color: ${COLORS.button};
      width: 100%;
      /* display: flex; */
      /* height: 100vh; */
      /* justify-content: center;
      align-items: center; */
      /* margin: 0 auto;
      text-align: center; */
    }
  `;

  const Item = styled.div`
    /* padding: 0; */
    display: flex;

    /* justify-content: left; */
    /* width: 100%; */
    margin-top: 3rem;
    margin-right: 2.5rem;
    line-height: 3rem;
    .link {
      color: ${COLORS.title};
      font-size: 1.8em;
      width: 100%;
      margin-bottom: 2rem;
    }
    :hover {
      border-bottom: 1px solid ${COLORS.button};
    }
    @media screen and (max-width: 912px) {
      margin-right: 0;
      margin-right: 1.3rem;
      .link {
        display: flex;
        justify-content: center;
      }
      :hover {
        /* border-bottom: 1px solid ${COLORS.text}; */
      }
    }
    /* @media screen and (max-width: 768px) {
      width: 100%;
      padding: 0;
      margin-bottom: 1.2rem; */
    /* display: flex; */
    /* text-align: center;
      :hover {
        border-bottom: 1px solid ${COLORS.button};
        width: 100%; */
    /* .link {
      color: ${COLORS.title};
      font-size: 1.8em;
      width: 50%; */
    /* margin: 0 auto; */
    /* height: 100vh;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: ${COLORS.button}; */
    /* }
    } */
  `;

  const Contact = styled(Item)`
    /* margin-right: 10rem; */
    @media screen and (max-width: 912px) {
      margin-right: 0;
    }
    @media screen and (max-width: 768px) {
      padding: 0;
    }
  `;
  const Toggle = styled.button`
    font-size: 2.5em;
    position: absolute;
    top: 24px;
    right: 32px;
    /* display: none; */

    /* @media screen and (max-width: 768px) {
      display: block;
      top: 16px;
      right: 16px;
      color: ${COLORS.button};
    } */
  `;

  //   const Text = styled.div`
  //     color: white;
  //   `;

  return (
    <NavWrapper>
      <Navbar>
        <Logo>
          <Link to="/">
            <LogoImg />
          </Link>
        </Logo>
        <Menu style={{ display: isOpen ? "block" : "none" }}>
          <Item>
            <Link to="/work" className="link" onClick={() => setOpen(false)}>
              Work
            </Link>
          </Item>
          <Item>
            <Link to="/about" className="link" onClick={() => setOpen(false)}>
              About
            </Link>
          </Item>
          <Contact>
            <Link to="/contact" className="link" onClick={() => setOpen(false)}>
              Contact
            </Link>
          </Contact>
        </Menu>
        <Toggle>
          {/* <FontAwesomeIcon icon={faBars} /> */}
          <Hamburger
            rounded
            direction="left"
            size={50}
            duration={0.3}
            toggled={isOpen}
            toggle={setOpen}
            onToggle={(toggled) => {
              if (toggled) {
                console.log("open menu");
                setOpen(true);
              } else {
                console.log("close menu");
                setOpen(false);
              }
            }}
          />
        </Toggle>
      </Navbar>
    </NavWrapper>
  );
}

export default Navbar;
